module.exports = __webpack_public_path__ + "media/icons/video-bb016841.svg";